import { render, staticRenderFns } from "./ReportSection.vue?vue&type=template&id=d8089d20&"
import script from "./ReportSection.vue?vue&type=script&lang=js&"
export * from "./ReportSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8089d20')) {
      api.createRecord('d8089d20', component.options)
    } else {
      api.reload('d8089d20', component.options)
    }
    module.hot.accept("./ReportSection.vue?vue&type=template&id=d8089d20&", function () {
      api.rerender('d8089d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportSection/ReportSection.vue"
export default component.exports